import type * as React from 'react';
import { useAutoResize } from '~/hooks/use-auto-resize';
import { cn } from '~/utils/cn';

export interface TextareaProps extends React.ComponentProps<'textarea'> {
  autoResize?: boolean;
}

export function Textarea({ className, autoResize = false, ref, ...props }: TextareaProps) {
  const { areaRef } = useAutoResize(autoResize);

  // A caller's ref (e.g. react-hook-form's) and the auto-resize ref both need the node.
  const setRefs = (node: HTMLTextAreaElement | null) => {
    areaRef.current = node;
    if (typeof ref === 'function') ref(node);
    else if (ref) ref.current = node;
  };

  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'field-sizing-content focus-effect flex min-h-16 w-full rounded-md border border-input bg-background px-3 py-2 text-md outline-hidden transition-[color,box-shadow] placeholder:text-muted-foreground disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 sm:text-sm dark:aria-invalid:ring-destructive/40',
        autoResize && 'resize-none overflow-hidden',
        className,
      )}
      ref={setRefs}
      {...props}
    />
  );
}
